<script lang="ts">
  import { convertToFormattedLocaleDate } from "@shared/svelte/Components/DateFormatter/LocaleString.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import type { SharedOrder } from "@shared/types/Order";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  export let order: SharedOrder;

</script>

<header class="fizz-surface" id="detail-header">
  <main class="fizz-container fizz-flex-row fizz-inset-square-16 fizz-align-content-start">
    <section class="fizz-flex-item fizz-flex-row-8-responsive">
      <div class="fizz-flex-row" class:fizz-stack-4={$LayoutStore.isMobile}>
        <UIRouterLink
          button={true}
          classes={"fizz-text-brand cursor-pointer"}
          params={{}}
          stateName={"layout.order_groups"}
        >
          <Icon height={"20"} type={"ArrowLeft"} width={"20"} />
        </UIRouterLink>
        <span class="fizz-text-strong">
          {convertToFormattedLocaleDate(order.created_at)}
        </span>
      </div>
      {#if order.sf_order_import === true}
        <div><span class="fizz-badge $spacing-16">SevenFifty order</span></div>
      {/if}
    </section>
    <section class="fizz-flex-column">
      <UIRouterLink
        classes={"fizz-text-strong"}
        stateName={"layout.product_listing"}
        params={{ distributors: order.distributor.id }}
      >
        {order.distributor_name}
      </UIRouterLink>
      <span class="fizz-text-medium fizz-flex-row fizz-justify-end">
        Order #{order.id}
      </span>
    </section>
  </main>
</header>
